import { useMutation } from '@tanstack/react-query';
import { updateUserInsightsShowActiveSubGoals } from 'shared/services/backend-api';

export const useUpdateInsightsShowActiveSubGoalsMutation = () =>
  useMutation({
    mutationFn: async (showActiveSubGoals: boolean) =>
      updateUserInsightsShowActiveSubGoals(showActiveSubGoals),
  });
